
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fast-track",
      function () {
        return require("private-next-pages/fast-track.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fast-track"])
      });
    }
  